export const providerOptionsForTrackingMode = ({ providerOptionsByTreatmentType, treatmentType, isRetentionMode }) => {
  if (!isRetentionMode) {
    return providerOptionsByTreatmentType[treatmentType]
  }

  return Object.values(providerOptionsByTreatmentType)
    .flat()
    .filter((option, index, options) => options.findIndex(candidate => candidate.value === option.value) === index)
}
